exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-box{background-color:#ffffff;width:990px;margin:auto;padding:40px 25px;box-shadow:0px 2px 2px rgba(0,0,0,0.05);border-radius:3px}.container-box .col-md-7 img{padding:4% 0px;width:75%}.deviceMobileApp{margin:35px 0px 45px}h3{color:#265390;font-size:24px;text-shadow:none;bottom:auto;font-weight:600}img{margin:25px 0px}.btn-primary{margin:0px 10px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/intro-wizard/start/start.component.scss
// module id = 1356
// module chunks = 7